import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { useSupportService } from "serviceHooks";
import { useCheckRelations } from "components/common";

function useSupportMessageResolveConfirm() {
  const supportService = useSupportService();
  const onConfirm = (supportIssueId: number) => supportService.confirm(supportIssueId);

  const onResolve = (supportIssueId: number) => supportService.markAsResolved(supportIssueId);

  const { getIsAuditor } = useCheckRelations();
  const isAuditor = getIsAuditor();

  const getCanClear = (
    state: WintSuperkollAPIModel.SupportIssueState,
    isUnread: boolean,
    isUnreadByCurrentUser: boolean
  ) =>
    (state === WintSuperkollAPIModel.SupportIssueState.Closed && !isAuditor && isUnread) ||
    (state !== WintSuperkollAPIModel.SupportIssueState.AtCustomer && isUnreadByCurrentUser);

  return { onConfirm, onResolve, getCanClear };
}

export default useSupportMessageResolveConfirm;
